import React, {useState, useEffect} from "react";
import {Row, Col} from "react-bootstrap";
import axios from "axios";
import {useHistory} from "react-router-dom";
import HeaderInfluxs from "./headerInfluxs";

function ActionDetails() {
    const uriActionDetails = "https://bo.influxs.live/StraKingAPI00X/api/action_detail";
    const [detailsOfAction, setDetailsOfAction] = useState({
        campaign: "",
        date_j: "",
        link: "",
        platform: "",
        product: "",
        text: "",
        type: ""
    });
    const [kpisValue, setKpisValue] = useState(null)
    const [actionFiles, setActionFiles] = useState(null)

    let history = useHistory();

    useEffect(() => {
        const token = localStorage.getItem('token');
        const actionId = localStorage.getItem('actionId');
        console.log(actionId);
        const api = axios.create({
            baseURL: uriActionDetails,
            headers: {'Authorization': 'Bearer ' + token}
        });
        getActionDetailsData();

        async function getActionDetailsData() {
            api.get(uriActionDetails + "/" + actionId).then(
                res => {
                    console.log(res);
                    setDetailsOfAction({
                        ...detailsOfAction,
                        date_j: res.data.action_detail.date_j,
                        link: res.data.action_detail.link,
                        text: res.data.action_detail.text,
                        type: res.data.action_detail.type,
                        product: res.data.action_detail.product,
                        campaign: res.data.action_detail.campaign,
                        platform: res.data.action_detail.platform,
                    });
                    setActionFiles(res.data.action_files);
                    setKpisValue(res.data.action_kpis);
                }
            ).catch(err => {
                alert(err.response.data.message);
            })

        }
    }, );

    return (
        <div className="contraDetail">
            <HeaderInfluxs/>
            <div className="list-of-contra-header">
                <h1>Détails d'une action</h1>
                <Row>
                    <Col>
                        <div>
                            <button className="button" onClick={
                                () => {
                                    history.push('/createKpis');
                                }
                            }>Mettre a jour les Kpis et les fichiers
                            </button>
                        </div>

                    </Col>
                    <Col>
                        {/*<div>*/}
                        {/*    <button className="button"onClick={*/}
                        {/*        () => {*/}
                        {/*            history.push('/createAction');*/}
                        {/*        }*/}
                        {/*    }>Modifier une action</button>*/}
                        {/*</div>*/}
                    </Col>
                </Row>
                &nbsp;
                <Row>
                    <Col>
                        <div className="login_form">
                            <form>
                                <div className="form-inner">
                                    <Row>
                                        <Col>
                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Date creation de L'action</label>
                                                    <input type="text" name="campaign"
                                                           id="campaign"
                                                           defaultValue={detailsOfAction.date_j}
                                                           value={detailsOfAction.date_j}/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Type de Campagne</label>
                                                    <input type="text" name="campaign"
                                                           id="campaign"
                                                           defaultValue={detailsOfAction.campaign}
                                                           value={detailsOfAction.campaign}/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Produit touche pas l'action</label>
                                                    <input type="text" name="campaign"
                                                           id="campaign"
                                                           defaultValue={detailsOfAction.product}
                                                           value={detailsOfAction.product}/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Plateforme ou l'action a été posté</label>
                                                    <input type="text" name="campaign"
                                                           id="campaign"
                                                           defaultValue={detailsOfAction.platform}
                                                           value={detailsOfAction.platform}/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Type d'action</label>
                                                    <input type="text" name="campaign"
                                                           id="campaign"
                                                           defaultValue={detailsOfAction.type}
                                                           value={detailsOfAction.type}/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Description de l'action</label>
                                                    <input type="text" name="campaign"
                                                           id="campaign"
                                                           defaultValue={detailsOfAction.text}
                                                           value={detailsOfAction.text}/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="link">Lien de la publication</label>
                                                    <button className="button">voir la publication</button>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col>
                                            {kpisValue && kpisValue.length > 0 ? (
                                                <div className="contra">
                                                    {kpisValue.map((contr, index) => (
                                                        <div key={index}>
                                                            <div className="UserInfo">
                                                                <li className="list-of-action">
                                                                    {/*<span><img className="icon"*/}
                                                                    {/*           src={contr.logo}*/}
                                                                    {/*           alt=""/></span>*/}
                                                                    <span> {contr.label}:
                                        <span>{contr.value}</span>
                                    </span>

                                                                </li>
                                                            </div>
                                                        </div>

                                                    ))}

                                                </div>
                                            ) : <div> </div>}
                                        </Col>
                                    </Row>
                                </div>

                            </form>
                        </div>
                    </Col>
                    <Col>
                        <div className="login_form">
                            <form>
                                <div className="form-inner">
                                    {actionFiles && actionFiles.length > 0 ? (
                                        <div className="contra">
                                            {actionFiles.map((contr, index) => (
                                                <div key={index}>
                                                    <div className="UserInfo">
                                                        <li className="list-of-action">
                                                                <span>
                                                                    <img className="galery"
                                                                         src={contr.link}
                                                                         alt=""/></span>

                                                        </li>
                                                    </div>
                                                </div>

                                            ))}

                                        </div>
                                    ) : <div> </div>}
                                </div>

                            </form>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default ActionDetails;